<template>
    <div class="total-order-prices">
        <PricesWithCommission
            :order-prices="priceInSystemCurrency"
            :title="title"
            :vat-calculated-amount-by-each-service-brutto="vatCalculatedAmountByEachServiceBrutto"
            :is-show-net-value="isShowNetValue"
            :is-show-v-a-t-commission="isShowVATCommission"
        >
            <v-tooltip v-if="showConvertPrices" v-model="show" location="top" width="260">
                <template v-slot:activator="{props}">
                    <v-btn
                        v-bind="props"
                        size="small"
                        icon="mdi-cash-multiple"
                        variant="text"
                        density="compact"
                        color="grey"
                        class="mx-2 mb-2"
                        data-cy="show-currency-multiple"
                        @click="show = !show"
                    />
                </template>
                <PricesWithCommission
                    :order-prices="orderPrices"
                    :vat-calculated-amount-by-each-service-brutto="vatCalculatedAmountByEachServiceBrutto"
                    :is-show-net-value="isShowNetValue"
                    :is-show-v-a-t-commission="isShowVATCommission"
                />
            </v-tooltip>
        </PricesWithCommission>
        <div class="commission-block align-center justify-space-between flex-wrap gc-4 gr-2">
            <slot />
            <payment-status-label class="ml-auto" :status="paymentStatus" :card-guarantee="serviceCardGuarantee" />
        </div>
        <!-- UI-24-1: sustainability rate breakdown (own-product SUSTAINABLE/ZERO rooms only).
             The breakdown component reads `services` + `orderPrices` itself. -->
        <SustainabilityPriceBreakdown v-if="title === 'client_price'" :services="services" :order-prices="orderPrices" />
    </div>
</template>

<script lang="ts">
    import {Component, toNative} from 'vue-facing-decorator'
    import __TotalOrderPrices, {TotalOrderPrices as _TotalOrderPrices} from '~src/components/account/snippets/TotalOrderPrices.vue'
    import PaymentStatusLabel from '~src/components/account/snippets/paymentStatusLabel.src'
    import PricesWithCommission from '~/components/account/snippets/PricesWithCommission.vue'
    import SustainabilityPriceBreakdown from '~/components/account/snippets/SustainabilityPriceBreakdown.vue'

    // UI-24-1: inject the sustainability price breakdown into the client price block.
    // Mixin-extends the core class (inherits all props/getters) and provides a custom
    // template that appends <SustainabilityPriceBreakdown>. Core behavior unchanged
    // for other builds (this override only exists in the zsh layer).
    @Component({components: {PricesWithCommission, PaymentStatusLabel, SustainabilityPriceBreakdown}})
    export class TotalOrderPrices extends _TotalOrderPrices {}

    export default {...toNative(TotalOrderPrices)}
</script>

<style lang="scss" scoped>
    @use 'vuetify/settings';
    @use 'sass:map';

    .v-tooltip :deep(.v-overlay__content) {
        background-color: white;
        color: black;
        box-shadow: 0 6px 10px rgba(0, 0, 0, 0.25);
    }
</style>
